import i18n from '@/locales'

const EXAMPLE_KEY_MAP = {
  'resource release': 'iam.topic.sms_template.example.resource_release',
  'password expire': 'iam.topic.sms_template.example.password_expire',
  'user lock': 'iam.topic.sms_template.example.user_lock',
}

export function getSmsTemplateVars (topic = {}) {
  switch (topic.name) {
    case 'resource release':
      return ['name', 'resource_type', 'advance_days', 'project', 'brand', 'billing_type']
    case 'password expire':
      return ['name', 'advance_days']
    case 'user lock':
      return ['name']
    default:
      if (topic.type === 'security') return ['name']
      if (topic.type === 'automated_process') return ['name', 'resource_type', 'status']
      return ['name', 'resource_type', 'project', 'brand', 'status']
  }
}

export function getSmsTemplateExtraTexts (topic = {}) {
  const vars = getSmsTemplateVars(topic).map(v => `\${${v}}`).join(' ')
  const exampleKey = EXAMPLE_KEY_MAP[topic.name] || 'iam.topic.sms_template.example.default'
  return [
    i18n.t('iam.topic.sms_template.extra'),
    i18n.t('iam.topic.sms_template.vars', [vars]),
    i18n.t(exampleKey),
  ]
}
